import ViewEmployeeDataModal from './ViewEmployeeDataModal'

export default ViewEmployeeDataModal
